import React from "react";
import { connect } from "react-redux";
import { aceptoConfidencialidad } from "./servicios.act";

import ConfidencialidadForm from "../gnp-registro-seguridad/contrato-datos.frm";

const mapState = (state) => {
	return {
		uid: state.recuperar.uid,
		dispositivo: state.global.dispositivo,
		estatus: state.recuperar.estatus,
	};
};

const mapDispatch = (dispatch,ownProps) => {
	return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show});
		},
		aceptoConfidencialidad: (uid,dato,dispositivo,estatus) => {
			dispatch(aceptoConfidencialidad(uid,dato));
			if(estatus == "m"){
				dispatch({ "type": "EVENT_UMIGRADO_CONFIDENCIALIDAD_"+dato, "flujo": "UsuarioMigrado", "dispositivo": dispositivo });
			} else{
				if(dato == "true"){
					dispatch({ "type": "EVENT_REGISTRO_SIG-CONSENTIMIENTO-ACEPTAR", "flujo": "UsuarioRegistro", "dispositivo": dispositivo });	
				}
				else{
					dispatch({ "type": "EVENT_REGISTRO_SIG-CONSENTIMIENTO-RECHAZAR", "flujo": "UsuarioRegistro", "dispositivo": dispositivo });	
				}
			}
		}
	};
};

class Confidencialidad extends React.Component{

	submit = (data) => {
	   this.props.loader(true);
	   if(data.acepto) {
			this.props.aceptoConfidencialidad(this.props.uid,"true",this.props.dispositivo,this.props.estatus);
		} else {
			this.props.aceptoConfidencialidad(this.props.uid,"false",this.props.dispositivo,this.props.estatus);
		}
	}

	render() {
		return <ConfidencialidadForm onSubmit={this.submit} />;
	}    
}

export default connect(mapState, mapDispatch)(Confidencialidad);


// WEBPACK FOOTER //
// ./src/gnp-recuperar-contrasenia/confidencialidad.cmpt.js